//lazyload
import LazyLoad from "vanilla-lazyload";

$(document).ready(function(){
	var lazyLoadInstance = new LazyLoad({
		// Your custom settings go here
		// https://www.npmjs.com/package/vanilla-lazyload#-api
		threshold:250,
	});
})